import { useMemo } from 'react';
import {
  APPROVAL_BUILDER_VIEW_PERMISSIONS,
  APPROVAL_INSTANCE_VIEW_PERMISSIONS,
  APPROVAL_INBOX_VIEW_PERMISSIONS,
  APPROVAL_MATRIX_VIEW_PERMISSIONS,
} from '@/config/approvalPermissions';
import { usePermissions } from '@/hooks/usePermissions';

export function useApprovalAccess() {
  const { hasAny } = usePermissions();

  return useMemo(
    () => ({
      /** Entity workflow panels (lookup, timeline, inline approval). */
      canViewPanel: hasAny(...APPROVAL_INSTANCE_VIEW_PERMISSIONS),
      /** Workflow builder + metadata. */
      canViewBuilder: hasAny(...APPROVAL_BUILDER_VIEW_PERMISSIONS),
      /** Approval matrix page. */
      canViewMatrix: hasAny(...APPROVAL_MATRIX_VIEW_PERMISSIONS),
      /** Approval inbox / work approvals. */
      canViewInbox: hasAny(...APPROVAL_INBOX_VIEW_PERMISSIONS),
    }),
    [hasAny],
  );
}
